module.exports = __webpack_public_path__ + "img/GB.6f382b2d.png";